import { ApolloError } from '@apollo/client';

import { useErpSurveyAssignmentResultsQuery } from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { ISurveyAssignmentResults } from './surveyModel';

interface ISurveyAssignmentResultsHook {
  results?: ISurveyAssignmentResults;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0011 — the results page payload: assignment header, the full eligible
 * roster (including students who have not responded — «для дожима») and
 * per-question aggregates. Aggregation is backend-side; the NPS
 * promoter/passive/detractor split is derived client-side via `npsSplit`.
 */
export const useSurveyAssignmentResults = (
  assignmentId?: string,
): ISurveyAssignmentResultsHook => {
  const { data, loading, error, refetch } = useErpSurveyAssignmentResultsQuery({
    variables: { assignmentId: assignmentId || '' },
    skip: !assignmentId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  // Stable identity — consistent with useSurveys / useGroupSurveyAssignments.
  const stableRefetch = useStableRefetch(refetch);

  return {
    results: data?.surveyAssignmentResults ?? undefined,
    loading,
    error,
    refetch: stableRefetch,
  };
};
